/**
 * The duration for which a medication is prescribed.
 */
enum MedicationTerm {
    /**
     * The duration is unknown or not specified.
     */
    Unspecified,

    /**
     * The medication is prescribed for a specific period of time.
     */
    ShortTerm,

    /**
     * The medication is prescribed long-term.
     */
    LongTerm
}

export { MedicationTerm };
